import { Vector } from "./classes/Vector";
import { keepInView } from "./helpers/keep-in-view";

const GRAVITY = new Vector(Math.PI / 2, 10);

export function drawSnow(
  graphics,
  points,
  { rad, velocity, count, screen, isPointerDown }
) {
  graphics.beginFill(0xffffff);
  graphics.lineStyle();
  points.forEach((star, i) => {
    const mult = isPointerDown ? 2 : 1;
    const rate = star.size * 0.03;
    const sway = Math.sin(count + i * 2) * 5 * rate;
    star.vector.update(rad, velocity * 1.5 * mult);
    star.point.move(star.vector.x * rate, star.vector.y * rate);
    star.point.move(GRAVITY.x + sway, GRAVITY.y * rate);
    keepInView(star, screen);
    graphics.drawCircle(star.point.x, star.point.y, star.size);
  });
}
